import { IconButton, Typography } from '@material-ui/core';
import Info from '@material-ui/icons/Info';
import React from 'react';
import ReplyIcon from '@material-ui/icons/Reply';
import { useSelector } from 'react-redux';
import ArrowSlider from '../../../components/ArrowSlider';
import styles from '../OptionsBoardStyles';
import ModalTable from './Table';
import moment from 'moment';

const CallsViewer = ({
	highestActual,
	highestEdge,
	answerArrowPos,
	backgoSelect,
	setWatchListData,
	openOICall,
	toggleOICell,
	toggleModal,
	currentPriceArrowPos,
	strikeSliderPosition,
	showAdvancedBoard,
	rows,
	warnings,
}) => {
	const { appReducer } = useSelector((state) => state);
	const { isMobile, expiration, width } = appReducer;

	const hide = highestActual.rowIndex === 0 ? true : false;
	const showArrows = currentPriceArrowPos.value ? true : false;

	return (
		<div
			style={
				!isMobile
					? styles.basicFlexContainerCall
					: styles.basicFlexContainerCallMobile
			}
		>
			<div
				style={!isMobile ? styles.expirationTop : styles.expirationTopMobile}
			>
				{expiration ? moment(expiration).format('DD-MMM-YY') : ''}
			</div>
			<div
				style={
					isMobile
						? styles.callsHeaderFlexContainerMobile
						: {
								top: '41px',
								...styles.callsHeaderFlexContainer,
						  }
				}
				className='sticky'
			>
				<div
					style={{
						display: 'flex',
						flex: 1,
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Typography
						variant='inherit'
						component={!isMobile ? 'h3' : 'h4'}
						style={styles.callsHeader}
					>
						Calls
					</Typography>
					<IconButton
						color='primary'
						style={styles.infoButton}
						aria-label='Show Advanced Board'
						onClick={() => showAdvancedBoard()}
					>
						<Info />
					</IconButton>
				</div>
				{isMobile && (
					<IconButton
						aria-label='Refresh'
						size='small'
						color='primary'
						style={{ ...styles.refreshButton, color: 'white' }}
						onClick={() => backgoSelect()}
					>
						<ReplyIcon />
					</IconButton>
				)}
			</div>
			<ArrowSlider
				height={highestActual.rowIndex - highestEdge.rowIndex}
				arrowPos={answerArrowPos}
				hide={hide}
				side={'left'}
				warnings={isMobile ? null : warnings}
				isMobile={isMobile}
				basicAnswer={true}
				yStartingPosition={highestEdge.rowIndex}
			/>
			{showArrows ? (
				<div style={styles.currentPriceArrowsContainer}>
					<ArrowSlider
						noc={'noc'}
						width={width}
						height={0}
						arrowPos={0}
						yStartingPosition={strikeSliderPosition}
						strikeArrow
						basicStrike
						isMobile={isMobile}
						side={'left'}
					/>
					<ArrowSlider
						width={width}
						height={0}
						arrowPos={0}
						yStartingPosition={strikeSliderPosition}
						strikeArrow
						basicStrike
						isMobile={isMobile}
						side={'right'}
					/>
				</div>
			) : null}

			<ModalTable
				setWatchListData={setWatchListData}
				openOICall={openOICall}
				toggleModal={toggleModal}
				toggleOICell={toggleOICell}
				rows={rows}
			/>
		</div>
	);
};

export default CallsViewer;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BasicCallBoard/CallsViewer.jsx